import React, { useMemo } from 'react';

import dayjs from 'dayjs';
import { Table } from 'react-bootstrap';
import { FaSort, FaSortUp, FaSortDown } from 'react-icons/fa';
import { useFilters, useGlobalFilter, usePagination, useSortBy, useTable } from 'react-table';

import { TablePagination } from '../../../components';

function getSortIcon(isSorted, isSortedDesc) {
  let iconProp = <FaSort />;
  if (isSorted) {
    iconProp = isSortedDesc ? <FaSortDown /> : <FaSortUp />;
  }
  return iconProp;
}

const ServiceNotesTable = ({ data }) => {
  const memoData = useMemo(() => data, [data]);

  const columns = useMemo(
    () => [
      {
        Header: 'Date and Time',
        accessor: 'createdAt',
        Cell: ({ value }) => dayjs(value).format('MM/DD/YYYY h:mm a'),
        className: 'align-middle text-nowrap',
        style: { width: '15%' },
      },
      {
        Header: 'User',
        accessor: 'userName',
        className: 'align-middle text-nowrap',
        style: { width: '20%' },
      },
      {
        Header: 'Note',
        accessor: 'text',
        className: 'align-middle',
      },
    ],
    [],
  );

  const tableInstance = useTable(
    {
      columns,
      data: memoData,
      initialState: {
        sortBy: [
          {
            id: 'createdAt',
            desc: true,
          },
        ],
        pageSize: 5,
      },
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
  );

  const { getTableProps, getTableBodyProps, headerGroups, page, prepareRow } = tableInstance;

  const tableHeaders = headerGroups.map(headerGroup => {
    const headers = headerGroup.headers.map(column => {
      const { key: thKey, ...thProps } = column.getHeaderProps(column.getSortByToggleProps());
      return (
        <th key={thKey} {...thProps}>
          {column.render('Header')}
          <span>{column.canSort ? getSortIcon(column.isSorted, column.isSortedDesc) : null}</span>
        </th>
      );
    });
    const { key: trKey, ...trProps } = headerGroup.getHeaderGroupProps();
    return <tr key={trKey} {...trProps}>{headers}</tr>;
  });

  const tableRows = page.map(row => {
    prepareRow(row);
    const cells = row.cells.map(cell => {
      const { key: tdKey, ...tdProps } = cell.getCellProps({
        className: cell.column.className,
        style: cell.column.style,
      });
      return (
        <td key={tdKey} {...tdProps}>
          {cell.render('Cell')}
        </td>
      );
    });

    const { key: trKey, ...trProps } = row.getRowProps();
    return <tr key={trKey} {...trProps}>{cells}</tr>;
  });

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
      <TablePagination tableInstance={tableInstance} />
      <Table {...getTableProps()} bordered>
        <thead>{tableHeaders}</thead>
        <tbody {...getTableBodyProps()}>
          {tableRows.length === 0 ? (
            <tr>
              <td colSpan={3} style={{ textAlign: 'center', padding: 16 }}>
                No notes yet.
              </td>
            </tr>
          ) : (
            tableRows
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default ServiceNotesTable;
